import { addError, initialise } from "@wayflyer/blackbox-fe";
import { getBundleVersion } from "shared-utils";
import { viewPathsOwners, displayOwners, posthogConfig } from "shared-ui";
import { createBrowserHistory } from "history";
import { matchRoutes } from "react-router-dom";

import { renderRootComponent } from "./libs/app/renderRootComponent";
import { baseConfig } from "./libs/configs/datadog";
import { ENV_CONFIG } from "./env";
import { router } from "./router";
import "./browser-storage";
import "./globals.css";

const env = ENV_CONFIG.PROD && !window.origin.includes("dev") ? "prod" : "local";
const version = getBundleVersion() ?? `customer-web@${ENV_CONFIG.PACKAGE_VERSION}`;

initialise({
  datadog: {
    ...baseConfig[env],
    version,
  },
  viewPathsOwners,
  displayOwners,
  posthog: posthogConfig,
});

const browserHistory = createBrowserHistory();

const updateTitle = (location) => {
  try {
    const matches = matchRoutes(router.routes, location);
    const lastMatch = matches?.[matches.length - 1];
    const title = (lastMatch?.route?.handle as { title?: string })?.title;
    document.title = `Wayflyer${env === "prod" ? "" : " (dev)"}${title ? ` - ${title}` : ""}`;
  } catch (error) {
    addError(new Error("Error setting page title", { cause: error }));
  }
};

updateTitle(window.location);

browserHistory.listen(({ location }) => {
  updateTitle(location);
});

renderRootComponent();
